module.exports = __webpack_public_path__ + "img/icon4.faae5b9.png";